import {
  faFlaskVial,
  faGlassWaterDroplet,
  faShirt,
  faWater,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import machine from "../../src/assets/machine.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logo from "../../src/assets/liquid-logo.png";
const NaturalDye = () => {

    const dyes = [
        { name: "Pomegranate Skin" },
        { name: "Indigo" },
        { name: "Tea" },
        { name: "Myrobalam" },
        { name: "Acacia Catechu" },
        { name: "Madder" },
      ];
    

  return (
    <div className="bg-white matchfont max-w-screen-lg mx-auto py-10">
      {/* Introduction Section */}

      <div className="flex justify-center items-center w-full">
        <div className="w-72 md:w-[600px] h-2 bg-gray-300 mb-12"></div>
      </div>

      <div className="flex flex-col justify-center items-center">
        <section className="text-justify md:w-[60%] mb-12 px-4">
          <h2 className="text-lg md:text-3xl text-center font-bold mb-4">INTRODUCTION</h2>
          <p className="text-gray-700 leading-relaxed">
            According to the EU, the textile industry accounts for 20% of global
            water contamination and 10% of CO2 emissions. Beyond the
            environmental impact of cotton cultivation, the{" "}
            <span className="font-bold text-black">synthetic dyeing</span>{" "}
            process of fabrics, yarns, and garments demands significant water
            and energy resources, generating hazardous waste byproducts that
            contribute to{" "}
            <span className="font-bold text-black">
              air, water, and soil pollution
            </span>
            .
          </p>
          <p className="text-gray-700 mt-4 leading-relaxed">
            In contrast to synthetic dyeing, which uses thousands of harmful
            chemicals,{" "}
            <span className="font-bold text-black">natural dyeing</span> relies
            solely on{" "}
            <span className="font-bold text-black">plant-based extracts</span>{" "}
            like leaves, barks, roots, etc..{" "}
            <span className="font-bold text-black">Synthetic dyes</span> damage
            the environment, aect the health of both wearers and workers, and
            pollute rivers, ecosystems, and soil bacteria.
          </p>
          <p className="text-gray-700 mt-4 leading-relaxed">
            Alongside the enormous water consumption, the main issue with{" "}
            <span className="font-bold text-black">synthetic dyeing</span>
            is the{" "}
            <span className="text-black font-bold">
              highly toxic sludge
            </span>{" "}
            produced as waste. Despite regulations, this sludge often finds its
            way into the environment through unregulated channels, as proper
            disposal remains unsolved
          </p>
          <p className="text-gray-700 mt-4 leading-relaxed">
            <span className="font-bold text-black">
              Recycling synthetically dyed clothing is not a sustainable
              solution for a closed, circular economy;
            </span>{" "}
            it actually worsens the issue. Each recycling cycle requires
            additional synthetic dyeing, contributing to ongoing environmental
            pollution
          </p>
        </section>
      </div>

      <div className="flex flex-col justify-center items-center">
        {/* Natural Dyeing Process */}
        <div className="flex justify-center items-center w-full">
          <div className="w-72 md:w-[600px] h-2 bg-gray-300 mb-12"></div>
        </div>
        <section className="text-justify md:w-[60%] mb-12 px-4">
          <h2 className="text-lg md:text-3xl text-center font-bold mb-4">
            NATURAL DYEING PROCESS
          </h2>
          <p className="text-gray-700 leading-relaxed">
            <span className="text-black font-bold">Natural Dye</span> stands for
            truly zero discharge and involves water treatment processes designed
            to replace harmful waste water with clean water suitable for reuse
            (e.g. irrigation).
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            <span className="text-black font-bold ">Natural Dyeing</span>{" "}
            systems utilize wastewater treatment and desalination technologies
            to recycle nearly all wastewater, eliminating the{" "}
            <span className="text-black font-bold ">
              need for industrial desalination
            </span>
            . By avoiding hazardous chemicals, they reduce both direct
            environmental impact and the indirect eects of energy consumption
            and CO2 emissions from thermal processes like evaporation,
            distillation, crystallizationand condensate recovery.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            <span className="font-bold text-black">Natural Dye </span>requires
            no industrial facilities and produces no hazardous solid waste.
            Natural Dyeing technologies enable facilities to meet reuse
            standards, comply with discharge regulations, achieve higher water
            recovery, and recover valuable materials from wastewater for reuse
            as agricultural fertilizer.
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            <span className="font-bold text-black">Natural Dye</span> aims to
            establish a sustainable, carbon-neutral, and socially responsible
            textile ecosystem, promoting an innovative and environmentally
            conscious approach to textile production globally.
          </p>
        </section>
      </div>
      {/* Images */}
      <section className="flex justify-center items-center mb-12 gap-1 md:gap-4 px-4">
        <img
          src={
            "https://plus.unsplash.com/premium_photo-1673292293042-cafd9c8a3ab3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bmF0dXJlfGVufDB8MXwwfHx8MA%3D%3D"
          }
          alt="Nature 1"
          className="rounded-sm w-1/3 object-cover"
        />
        <img
          src={
            "https://images.unsplash.com/photo-1668417863230-64f268d1d252?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8d2FzaGluZyUyMG1hY2hpbmV8ZW58MHwxfDB8fHww"
          }
          alt="Nature 2"
          className="rounded-sm w-1/3 object-cover"
        />
        <img
          src={
            "https://plus.unsplash.com/premium_photo-1681987447708-5ee4494d6d0e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fHNhdmUlMjBuYXR1cmV8ZW58MHwxfDB8fHww"
          }
          alt="Dye Process"
          className="rounded-sm w-1/3 object-cover"
        />
      </section>

      {/* Ingredients Section */}
      <div className="flex flex-col justify-center items-center">
        <div className="flex justify-center items-center w-full">
          <div className="w-72 md:w-[600px] h-2 bg-gray-300 mb-12"></div>
        </div>
        <section className="text-center flex flex-col justify-center items-center mb-12 px-4">
          <h2 className="text-lg md:text-3xl font-bold mb-4">INGREDIENTS</h2>
          <div className="md:w-[60%] ">
          <p className="text-gray-700 text-justify leading-relaxed mt-4"><span className="font-bold text-black">Natural Dyes</span> are sourced from plant-based materials such as barks, leaves, roots, 
and other agricultural residues, that oer a viable alternative aligns with principles 
environmental conservation, energy eciency and human health</p>
<p className="text-gray-700 text-justify leading-relaxed mt-4"><span className="font-bold text-black">Natural Ingredients</span> play a significant role in promoting permaculture, natural ecosystems and biodiversity, ensuring longterm soil sustainability and additional income for farmers</p>
          </div>
          <div className="flex bg-transparent justify-center items-center min-h-screen  p-4">
      <div className=" p-6  rounded-md w-full max-w-4xl">
       

        {/* Table */}
        <div className="grid grid-cols-4 gap-6">
          {/* Left Column: Plant Names */}
          <div className="col-span-1">
            {dyes.map((dye, index) => (
              <div key={index} className="flex flex-col items-center mb-8">
                <div className="h-12 w-12 border border-gray-300 rounded-full flex justify-center items-center">
                  <img src={logo} alt="Plant Icon" className="h-10" />
                </div>
                <p className="text-center text-gray-700 ml-16 mb-8 text-xs font-medium rotate-90">
                  {dye.name}
                </p>
              </div>
            ))}
          </div>

          {/* Right Columns: Logo Grid */}
          <div className="col-span-3 grid grid-cols-3 gap-6">
            {dyes.map((_, rowIndex) =>
              [1, 2, 3].map((_, columnIndex) => (
                <div
                  key={`${rowIndex}-${columnIndex}`}
                  className="w-16 h-20 rounded-lg  flex justify-center items-center"
                >
                  <img
                    src={logo}
                    alt="Logo"
                    className="h-12 w-12 object-contain"
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
        </section>
      </div>
      {/* Reasons to Change */}
      <section className="text-center my-12 px-4">
        <div className="flex justify-center items-center w-full">
          <div className="w-[600px] h-2 bg-gray-300 mb-12"></div>
        </div>
        <h2 className="text-lg lg:text-3xl font-bold mb-4">REASONS TO CHANGE</h2>

        <div className="grid md:grid-cols-5 gap-10 mt-8">
          <div>
            <FontAwesomeIcon icon={faShirt} className="text-5xl" />
            <p className="text-gray-700 text-justify mt-2 leading-relaxed">
              An average T-Shirt consumes about <span className="text-black font-bold">2,495</span> liters of water
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-2">
              Note: For 1kg of garments 10.000 liter water are needed!
            </p>
          </div>

          <div>
            <img src={machine} alt="image" className="w-12 h-12 mx-auto" />
            <p className="text-gray-700 text-justify mt-2 leading-relaxed">
              The fashion industry is responsible for:
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-4">
              <span className="font-bold text-black">- 10%</span> of annual<span className="text-black font-bold"> global CO2 emissions</span>.
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-4">
              <span className="text-black font-bold">- 20%</span> of <span className="font-bold tex-black">global wastewater</span> comes from dyeing and fabric
              processing.
            </p>
          </div>

          <div>
            <FontAwesomeIcon icon={faWater} className="text-5xl" />
            <p className="text-gray-700 text-justify mt-2 leading-relaxed">
              At a time when all continents are facing water scarcity, the
              textile industry uses <span className="text-black font-bold">7-9 trillion liters</span> of water every year,
              just for dyeing fabrics.
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-2">
              Note: That’s like filling more than two million Olympic swimming
              pools every year with fresh water!
            </p>
          </div>
          <div>
            <FontAwesomeIcon icon={faGlassWaterDroplet} className="text-5xl" />
            <p className="text-gray-700 text-justify mt-2 leading-relaxed">
              Natural dyeing uses <span className="text-black font-bold">local plant based ingredients</span>
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-2">
              <span className="text-black font-bold">No heavy industry</span> is required for the ink production, which mean
              immense energy and water savings.
            </p>
          </div>
          <div>
            <FontAwesomeIcon icon={faFlaskVial} className="text-5xl" />
            <p className="text-gray-700 text-justify mt-2 leading-relaxed">
              Almost 3/4 of the water consumed by dye works end up as inedible
              waste - a <span className="text-black font-bold">toxic soup of dyes, salts, alkalis, heavy metals, and
              chemicals </span>that were used to dye our clothes.
            </p>
            <p className="text-gray-700 text-justify leading-relaxed mt-2">
              Note: That is equivalent to approx. 8 million tons of waste every
              year or 2-3 million elephants
            </p>
          </div>
        </div>
      </section>

      {/* Environmental Impact */}
      <div className="flex flex-col justify-center items-center">
        <section className="text-center md:w-[60%] text-justify mb-12 px-4">
          <div className="flex justify-center items-center w-full">
            <div className="w-72 md:w-[600px] h-2 bg-gray-300 mb-12"></div>
          </div>
          <h2 className="text-lg md:text-3xl text-center font-bold mb-4">
            ENVIRONMENTAL IMPACT
          </h2>
          <p className="text-gray-700 leading-relaxed">
            The term <span className="font-bold text-black">'sustainability'</span> has become a buzzword, often diluted by
            <span className="font-bold text-black">'greenwashing.'</span> It is crucial to educate consumers on the intrinsic
            connection between clothing and sustainable practices. This
            education will help prevent misconceptions and promote genuine
            eco-friendly alternatives. Natural dyed clothing is a viable and
            sustainable alternative to conventional synthetic dyeing practices,
            even when applied to organically certified cotton textiles.
          </p>
          <p className="text-gray-700 mt-2 leading-relaxed">
            he retail sector plays a pivotal role in this educational eort by
            promoting transparency in the supply chain. Despite the prevalence
            of well-intentioned labels and certifications, few consumers take
            the time to investigate their authenticity and meaning. The
            increasing frequency of climate related disasters underscores the
            urgent need for radical changes in thinking and behavior across all
            sectors - farmers, manufacturers, retailers, consumers, and
            policymakers.
          </p>
          <p className="text-gray-700 mt-2 leading-relaxed">
            Based on our strong belief in a substantial change for a ecological
            and social sustainability in the textile manufacturing, the
            continuous investigations and support, we were able to form an
            association among the players of complete supply chain of the
            manufacturing process of natural dyed garments. Our thanks go to the
            farmers, the spinning mill, the colour extraction unit, the dyeing
            mill and sewing units who together with the support of legal
            counselling, testing laboratories and strategic product development,
            made this change possible.....
          </p>
        </section>
      </div>

      {/* Thank You */}
      <section className="text-center px-4">
        <h2 className="text-lg lg:text-3xl font-bold text-gray-800">
          THANK YOU
          <br /> FOR JOINING OUR MISSION
          <br /> TO MAKE THE WORLD A BETTER PLACE...
        </h2>
      </section>
    </div>
  );
};

export default NaturalDye;
